<template>
	<div id="measure-list">
		<div class="sticky-table-header">
			<vx-card style="overflow-x: auto;">
				<vs-row>
						<vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
								<vs-input ref="searchTxt" icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Pencarian berdasarkan tanggal order/no lab/nama pasien" v-model="searchText"  v-on:keyup.enter="search"  v-on:keyup.tab="searchTabClick"/>
								<vs-tooltip text="Edit" v-if="btnEdit === true">
									<vs-button radius size="large" type="border" color="warning" icon="edit" class="ml-3" @click="edit()"></vs-button>
								</vs-tooltip>
								<vs-tooltip text="Hapus" v-if="btnDel === true">
									<vs-button radius size="large" type="border" color="danger" icon="delete" class="ml-3"></vs-button>
								</vs-tooltip>
						 </vs-col>
				</vs-row>
			</vx-card>
		</div>

		<vx-card title="Daftar Pemeriksaan" class="sticky-table-content1 mt-sticky">
			<vs-table stripe
				:class="showFixedHeader?'sticky-header':''"
				:data="listData"
				@selected="handleSelected">
				<template slot="thead">
					<vs-th class="vs-lg-2">Kode Healtri</vs-th>
					<vs-th class="vs-lg-1">Kode SIMRS<br/>Instrumen</vs-th>
					<vs-th class="vs-lg-4">Nama Pemeriksaan</vs-th>
					<vs-th class="vs-lg-2">Tipe Variabel</vs-th>
					<vs-th class="vs-lg-2">Etiket</vs-th>
					<vs-th class="vs-lg-1">Unit</vs-th>
				</template>
				<template slot-scope="{data}">
					<vs-tr :state="tr.id==idSelected?'primary':null" :data="tr" :key="indextr" v-for="(tr, indextr) in data"
					 :style="tr.id==idSelected?'background: rgba(var(--vs-primary),.1)!important;':''">
						<vs-td class="vs-lg-2 text-center">
							<b>{{data[indextr].htCode}}</b><br/>
								<label style="font-size: 12px">{{data[indextr].loincCode}} | {{data[indextr].code}}</label>
						</vs-td>
						<vs-td class="vs-lg-1 text-center">
							<b>{{data[indextr].hospitalCode}}</b><br/>
								<label style="font-size: 12px">{{data[indextr].instrumentCode}}</label>
						</vs-td>
						<vs-td class="vs-lg-4">
							<b>{{data[indextr].name}}</b><br/>
							<label style="font-size: 12px">{{data[indextr].htName}}</label>
						</vs-td>
						<vs-td class="vs-lg-2 text-center">
							{{data[indextr].measureType.name}}
						</vs-td>
						<vs-td class="vs-lg-2 text-center">
							<span v-if="data[indextr].tube"><vs-chip :color="data[indextr].tube.colorValue">{{data[indextr].tube.name}}</vs-chip></span>
						</vs-td>
						<vs-td class="vs-lg-1 text-center">
							{{data[indextr].unit}}
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
        <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>
		</vx-card>
	</div>

</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import lab from "@/api/lab.js";
import tool from "@/tool/form_tool.js";
import { VueContext } from "vue-context";


export default {
	components: {
		VueContext
	},
	data() {
		return {
			idSelected: null,
			listData: {maxPage:0, data: []},
			loading: true,
			perPage: 50,
			page: 1,
			totalItem: 1,

			btnEdit: false,
      		btnDel: false,

			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
      searchText: '',
      isUserScrolling: false,
      showFixedHeader: false,
      isMobile: false
		};
	},
	methods: {
		listen(newVal, schema) {
			if (schema == "provinceId") {
				this.getCityByProvince(false);
				return;
			}
		},
		async find(pg) {
			this.model["perPage"] = this.perPage;
			this.model["page"] = pg;
			const frm = await lab.listMeasure(this.model);
			if (frm.data.status != false) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
				this.listData= {maxPage:0, data: []};
			}
		},
		async search() {
      this.page = 1;
			this.model["perPage"] = this.perPage;
      this.model["page"] = 1;
      this.model["keyword"] = this.searchText
			const frm = await lab.listMeasure(this.model);
			if (frm.data.status) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
			   this.listData = [];
      }
		},
		handleSelected(tr) {
			this.idSelected = tr.id;
			this.btnEdit = true;
			this.btnDel = true;
		},
		edit() {
			this.$router.push({name: 'pemeriksaan-measure-edit', params: {id: this.idSelected}});
		},
    handleScroll(ev) {
      if(!this.isMobile) {
          this.isUserScrolling = (window.scrollY > 0);
          if (this.isUserScrolling) {
              if (window.pageYOffset > 45) {
                  this.showFixedHeader = true;
              } else {
                  this.showFixedHeader = false;
              }
          } else {
              this.showFixedHeader = false;
          }
      }
    },
    setFocusOnInput(inputName) {
       /**
        * @see https://vuejs.org/v2/api/#vm-el
        * @see https://vuejs.org/v2/api/#vm-refs
        */
        // you could just call this.$refs[inputName].focusInput() but i'm not shure if it belongs to the public API
        let inputEl = this.$refs[inputName].$el.querySelector('input');
        console.log(inputEl.focus);
        inputEl.focus();
    },
    isMobileDevice() {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        console.log(navigator.userAgent);

        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    }
	},
	computed: {

	},
	mounted() {
    	this.isMobile = this.isMobileDevice();
	},
	created() {
      document.addEventListener('scroll', this.handleScroll);
      this.$nextTick(() => this.setFocusOnInput('searchTxt'))
  },
  destroyed() {
      document.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
